import {Capability} from "../formElementCapability";

export const baseDropdownItemRestrictions: Array<Capability> = [Capability.selectable, Capability.labelable];

export function generateDropdownItemRestrictions(length: number, restrictions: Array<Capability>): Array<any> {
  const array = new Array(length).fill(restrictions);
  return array.map(r => {
    return {self: r}
  });
}

